import React from "react";
import {
    Breadcrumbs as MuiBreadCrumbs,
    Link,
    styled,
    Typography,
} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { IKlasisRoute, GetRoutes } from "../../configuration/routes";
import { useTranslation } from "react-i18next";
import { Translations } from "../../localization/translations";

const BreadcrumbLink = styled(Link)(() => ({
    "&": {
        textDecoration: "inherit",
        color: "inherit",
    },
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
})) as typeof Link;

const BreadcrumbCurrent = styled(Typography)(({ theme }) => ({
    "&": {
        color: theme.palette.primary.main,
    },
}));

export const Breadcrumbs = () => {
    const { t } = useTranslation();

    const getRoutes = (): IKlasisRoute[] => {
        /* Adding locale offset so that useBreadcrumbs can properly map to route */
        return [
            {
                path: "/",
                breadcrumb: t<string>(Translations.routes.title.home),
                children: [
                    {
                        path: ":locale",
                        children: GetRoutes(),
                    },
                ],
            },
        ];
    };

    const breadcrumbs = useBreadcrumbs(getRoutes(), {
        excludePaths: ["/", "/:locale/static-page"],
    });

    return (
        <MuiBreadCrumbs aria-label="breadcrumb">
            {breadcrumbs.map(({ match, breadcrumb }, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return isLast ? (
                    <BreadcrumbCurrent
                        color="text.primary"
                        key={match.pathname}
                    >
                        {breadcrumb}
                    </BreadcrumbCurrent>
                ) : (
                    <BreadcrumbLink
                        to={match.pathname}
                        component={RouterLink}
                        key={match.pathname}
                    >
                        {breadcrumb}
                    </BreadcrumbLink>
                );
            })}
        </MuiBreadCrumbs>
    );
};

export default Breadcrumbs;
